import { Dispatch } from 'redux';
const contributableLocales = require('../../../locales/contributable.json') as string[];
import { Clips } from './clips';
import { Sentences } from './sentences';
import { Recognitions } from './recognitions';
import StateTree from './tree';
import {S2TClips} from "./s2tclips";

export namespace Locale {
  export type State = string;

  enum ActionType {
    SET = 'SET_LOCALE',
  }

  interface SetAction {
    type: ActionType.SET;
    locale: string;
  }

  export type Action = SetAction;

  export const actions = {
    set: (locale: string) => (
      dispatch: Dispatch<SetAction | any>,
      getState: () => StateTree
    ) => {
      if (getState().locale == locale) return;
      dispatch({
        type: ActionType.SET,
        locale,
      });
      if (contributableLocales.includes(locale)) {
        dispatch(Sentences.actions.refill());
        dispatch(Recognitions.actions.refill());
        dispatch(S2TClips.actions.refillCache());
        dispatch(Clips.actions.refillCache());
      }
    },
  };

  export function reducer(state: State = null, action: Action): State {
    switch (action.type) {
      case ActionType.SET:
        return action.locale;

      default:
        return state;
    }
  }
}
